import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";

import { StylesDatePicker } from "../../ui/stylesDatePicker";
import { CustomLabel } from "../../ui/labels";
import { createOutOfOffice, updateOutOfOffice } from "../../services/outOfOfficeServices";
import { LabSelect } from "../course/select";
import { formatearFecha } from "../CandidatosNP/utils";

const createOrUpdateOutOfOffice = async (newOutOfOffice, id) => {
  if (id) {
    const res = await updateOutOfOffice(newOutOfOffice);
    if (res.isSoftError) {
      throw res.message;
    }
    return res.message;
  }

  const res = await createOutOfOffice(newOutOfOffice);
  if (res.isSoftError) {
    throw res.message;
  }
  return res.message;
};

function OutOfOfficeModal({ toggle, isOpen, currentOutOfOffice, piActivos, fetchOutOfOffice }) {
  const fechaActual = moment().format("YYYY-MM-DD");
  const [fechaDeste, setFechaDeste] = useState(moment().add(1, "days").format("YYYY-MM-DD"));
  const [fechaHasta, setFechaHasta] = useState(moment().add(1, "days").format("YYYY-MM-DD"));
  const [remplazo, setremplazo] = useState(null);

  useEffect(() => {
    if (currentOutOfOffice) {
      setFechaDeste(currentOutOfOffice.fechaComienzo);
      setFechaHasta(currentOutOfOffice.fechaFin);
      setremplazo(currentOutOfOffice.remplazo);
    }
  }, [currentOutOfOffice]);

  useEffect(() => {
    if (fechaDeste) {
      setFechaHasta(moment(fechaDeste).format("YYYY-MM-DD"));
    }
  }, [fechaDeste]);

  const piActivosOptions =
    piActivos && piActivos.rows
      ? piActivos.rows
          .map((item) => {
            return { label: item.nombreApellido, value: item.itemId };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleDatesChange = (values, name) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    if (name === "desde") setFechaDeste(fechaFormateada);
    if (name === "hasta") setFechaHasta(fechaFormateada);
  };

  const handleSave = async () => {
    const newOutOfOffice = {
      fechaComienzo: fechaDeste,
      fechaFin: fechaHasta,
      remplazo,
      id: currentOutOfOffice ? currentOutOfOffice.id : null,
      estado: 3, // cada cabio tiene que ser aprobado por el reemplazo
    };

    try {
      const message = await createOrUpdateOutOfOffice(newOutOfOffice, currentOutOfOffice ? currentOutOfOffice.id : null);

      toast.success(message);

      fetchOutOfOffice();
      toggle();
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <div style={{ width: "fit-content" }}>
      <Modal isOpen={isOpen} toggle={toggle} centered style={{ maxWidth: "560px" }}>
        <form className="theme-form">
          <ModalHeader className="border-0 pb-0" toggle={toggle} />
          <ModalBody className="pt-0 pb-0">
            <h5 className="badge-pills p-4 w-100">Configuración para Fuera de Oficina</h5>
            <div className="p-4 w-100">
              <form action="">
                <div className="d-flex justify-content-between">
                  <StylesDatePicker className="mb-1 mr-1 w-100">
                    <CustomLabel htmlFor="fechaAbierta" className="pt-0 w-100">
                      Desde:
                      <DatePicker
                        className="date-input digits w-100 border rounded"
                        dateFormat="AAAA-MM-dd"
                        onChange={(e) => handleDatesChange(e, "desde")}
                        value={formatearFecha(fechaDeste)}
                        selected={fechaDeste ? new Date(fechaDeste).setDate(new Date(fechaDeste).getDate() + 1) : null}
                        minDate={new Date(fechaActual).setDate(new Date(fechaActual).getDate() + 2)}
                      />
                    </CustomLabel>
                  </StylesDatePicker>

                  <StylesDatePicker className="mb-1 ml-1 w-100">
                    <CustomLabel htmlFor="fechaAbierta" className=" pt-0 w-100">
                      Hasta:
                      <DatePicker
                        className="date-input digits w-100 border rounded"
                        dateFormat="AAAA-MM-dd"
                        onChange={(e) => handleDatesChange(e, "hasta")}
                        value={formatearFecha(fechaHasta)}
                        selected={fechaHasta ? new Date(fechaHasta).setDate(new Date(fechaHasta).getDate() + 1) : null}
                        minDate={new Date(fechaDeste).setDate(new Date(fechaDeste).getDate() + 1)}
                        isDisabled={!fechaDeste}
                      />
                    </CustomLabel>
                  </StylesDatePicker>
                </div>
                <div className="my-3">
                  <CustomLabel htmlFor="piActivos" className="pt-0 w-100">
                    PI Asignable:
                  </CustomLabel>
                  <LabSelect
                    className="w-100"
                    name="personalInternoAsignado"
                    options={piActivosOptions}
                    onChange={(selected) => setremplazo(selected.value)}
                    value={piActivosOptions.find((option) => {
                      return option.value === remplazo;
                    })}
                    isDisabled={!piActivosOptions.length > 0}
                  />
                  <CustomLabel className="pt-1 w-100">Sólo se muestran PIs activos para asignar. No se muestran PIs que están fuera de oficina. </CustomLabel>
                </div>
              </form>
            </div>
          </ModalBody>
          <ModalFooter className="border-0 pt-0">
            <Button color="btn-secondary" onClick={toggle}>
              Cancelar
            </Button>
            <Button color="btn btn-primary" type="button" onClick={handleSave}>
              Guardar
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
}

export default OutOfOfficeModal;
